import * as PIXI from 'pixi.js';

import { APP_WIDTH, APP_HEIGHT } from '../utils/commonUtils';
import AssetsLoader from '../utils/assetsLoader';
import ButtonContainer from './buttonContainer';

export default class SettingsOverlayContainer extends PIXI.Container {
    constructor() {
        super();
        this.label = 'settingsOverlayContainer';
        this.visible = false;

        this.overlayFill = new PIXI.FillGradient({
            type: 'linear',
            colorStops: [
                { offset: 0, color: 'rgb(13, 13, 13)' },
                { offset: 0.5, color: 'rgba(36, 36, 36, 0.9)' },
                { offset: 1, color: 'rgb(13, 13, 13)' },
            ],
        });

        this.overlayEdgeFill = new PIXI.FillGradient({
            type: 'linear',
            start: { x: 0, y: 0.5 },
            end: { x: 1, y: 0.5 },
            colorStops: [
                { offset: 0, color: 'rgb(0, 0, 0)' },
                { offset: 0.1, color: 'rgba(1, 1, 1, 0)' },
                { offset: 0.9, color: 'rgba(1, 1, 1, 0)' },
                { offset: 1, color: 'rgb(0, 0, 0)' },
            ],
        });

        const settingsOverlayGraphics = new PIXI.Graphics();
        settingsOverlayGraphics.label = 'settingsOverlayGraphics';
        settingsOverlayGraphics.rect(-APP_WIDTH / 2, -APP_HEIGHT / 2, APP_WIDTH, APP_HEIGHT);
        settingsOverlayGraphics.fill(this.overlayFill);
        settingsOverlayGraphics.rect(-APP_WIDTH / 2 - 50, -APP_HEIGHT / 2, APP_WIDTH + 100, APP_HEIGHT);
        settingsOverlayGraphics.fill(this.overlayEdgeFill);
        this.addChild(settingsOverlayGraphics);

        const surrenderButton = new ButtonContainer({
            bgAssetName: AssetsLoader.eDefaultAssetsAliases.SETTINGS_SURRENDER_BUTTON,
            eventName: 'surrenderButtonClicked',
        });
        surrenderButton.label = 'surrenderButton';
        this.addChild(surrenderButton);

        this.wavesFooter = new PIXI.Sprite(PIXI.Assets.get(AssetsLoader.eDefaultAssetsAliases.WAVES_FOOTER));
        this.wavesFooter.label = 'wavesFooter';
        this.wavesFooter.x = 0;
        this.wavesFooter.y = APP_HEIGHT / 2;
        this.wavesFooter.width = APP_WIDTH;
        this.wavesFooter.anchor.set(0.5, 1);
        this.addChild(this.wavesFooter);

        this.chopperHidingSprite = new PIXI.Sprite(PIXI.Assets.get(AssetsLoader.eDefaultAssetsAliases.SETTINGS_CHOPPER_HIDING));
        this.chopperHidingSprite.label = 'chopperHidingSprite';
        this.chopperHidingSprite.x = -APP_WIDTH / 2;
        this.chopperHidingSprite.y = 355;
        this.addChild(this.chopperHidingSprite);
    }

    toggle() {
        this.visible = !this.visible;
    }

    resize(width, height) {
        const settingsOverlayGraphics = this.getChildByLabel('settingsOverlayGraphics');
        settingsOverlayGraphics.clear();
        settingsOverlayGraphics.rect(-width / 2, -height / 2, width, height);
        settingsOverlayGraphics.fill(this.overlayFill);
        settingsOverlayGraphics.rect(-width / 2 - 50, -height / 2, width + 100, height);
        settingsOverlayGraphics.fill(this.overlayEdgeFill);

        this.chopperHidingSprite.x = -width / 2;
        
        this.wavesFooter.width = width;
    }
}
